import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';

const AddZooplanktonOrganismDialog = ({
  isOpen,
  onClose,
  sampleType,
  organismName,
  onOrganismNameChange,
  onAddClick
}) => {
  const handleAdd = () => {
    onAddClick();
  };

  const handleClose = () => {
    onClose();
    onOrganismNameChange('');
  };

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle>Legg til ny organisme</DialogTitle>
        </DialogHeader>
        <div className="space-y-4">
          <div>
            <Label>Prøvetype</Label>
            <Input
              value={sampleType}
              disabled
              className="mt-2 bg-slate-100"
            />
          </div>
          <div>
            <Label>Organismenavn *</Label>
            <Input
              value={organismName}
              onChange={(e) => onOrganismNameChange(e.target.value)}
              placeholder="f.eks. Copepoder"
              className="mt-2"
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  e.preventDefault();
                  handleAdd();
                }
              }}
            />
          </div>
          <div className="flex space-x-2">
            <Button onClick={handleAdd} className="flex-1 bg-teal-600 hover:bg-teal-700">
              Legg til organisme
            </Button>
            <Button 
              variant="outline" 
              onClick={handleClose} 
              className="flex-1"
            >
              Avbryt
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default AddZooplanktonOrganismDialog;
